import { render, staticRenderFns } from "./DepositOffExchngeTemp.vue?vue&type=template&id=298af992&scoped=true"
import script from "./DepositOffExchngeTemp.vue?vue&type=script&lang=js"
export * from "./DepositOffExchngeTemp.vue?vue&type=script&lang=js"
import style0 from "./DepositOffExchngeTemp.vue?vue&type=style&index=0&id=298af992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298af992",
  null
  
)

export default component.exports